import React from 'react'
import PropTypes from 'prop-types'

import styles from './Tooltip.css'

const propTypes = {
    children: PropTypes.node.isRequired,
}

let showDeprecationWarning = true
/**
 * **@deprecated since version 2.0, will be deleted in version 3.0.
 * Use .subtitle element from tooltip mixin instead.**
 */
const TooltipSubtitle = (props) => {
    if (showDeprecationWarning) {
        console.warn('<TooltipSubtitle> component is deprecated, will be removed in version 4.0. Use .subtitle element from tooltip mixin instead.') // eslint-disable-line no-console
        showDeprecationWarning = false
    }

    return (
        <h2 className={styles.subtitle}>
            {props.children}
        </h2>
    )
}

TooltipSubtitle.propTypes = propTypes

export default TooltipSubtitle



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Tooltip/TooltipSubtitle.jsx